import React, { useState } from 'react';
import CloudStorage from '../../../CloudStorage/CloudStorage';
import MultyChartLineGraph from '../../Common/Graphs/MultyChartLineGraph';
import PaiChartGraph from '../../Common/Graphs/PaiChartGraph';
import BasicChartLineGraphHistory from '../../Common/Graphs/BasicChartLineGraphHistory';
import { Commas } from '../../Common/AllDateTimeReleventFormate';
import TimeWiseFilter from './GraphFilter/TimeWiseFilter';

export default function MyBusiness({ data, graph }) {
    const [firstdate, setFirstdate] = useState('')
    const [lastdate, setLastdate] = useState('')
    const [type, setType] = useState(1)

    const generateGraph = (growth, type) => {
        return growth < 0
            ? <img src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/graph2.png`} alt="" /> :
            <img src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/graph1.png`} alt="" />

    };

    const renderSatisfactionItem = (label, value, growth, imgSrc) => (
        <div className={`col-md-6 satisfication-border ${growth < 0 ? 'satisfication-left sat-bottom smile-sec negative' : 'satisfication-left'}`}>
            <div>
                <p>{label}</p>
                <h1>{value}</h1>
            </div>
            <div className="small-graph">
                {generateGraph(growth)}
            </div>
            <h5><span>{growth}% </span> vs preview, 28 day</h5>
        </div>
    );

    return (
        <div className="tab-pane active business-tab" id="business">
            <div className="row report-row">
                <div className="col-md-12 wallet-calendar" >
                    <h4>Completed Funnel</h4>
                    {/* <h1>First Date : {firstdate} </h1>
                    <h1>Last Date : {lastdate} </h1> */}
                    <TimeWiseFilter setFirstdate={setFirstdate} setLastdate={setLastdate} setType={setType} start_date={firstdate} end_date={lastdate} />
                    <MultyChartLineGraph history={data?.history} start_date={firstdate} end_date={lastdate} type={type} />
                </div>

                <div className="col-md-12">
                    <h4>Total Revenue</h4>
                    <BasicChartLineGraphHistory history={data?.history} start_date={firstdate} end_date={lastdate} type={type} />
                </div>

                <div className="col-md-6">
                    <div className="average-rating">
                        <h4>All Products</h4>
                        <PaiChartGraph reviews={data?.pichart} />
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="customer-satisfication">
                        <div className="row">
                            {renderSatisfactionItem('Price', `SAR ${Commas(data?.total?.price)}`, data?.total?.price_growth, 'graph1.png')}
                            {renderSatisfactionItem('Order Count', data?.total?.order_count, data?.total?.order_count_growth, 'graph2.png')}
                            {renderSatisfactionItem('Request Count', data?.total?.request_count, data?.total?.request_count_growth, 'graph1.png')}
                            {renderSatisfactionItem('Interested Buyers', data?.total?.visitor_count, data?.total?.visitor_count_growth, 'graph2.png')}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
